import GameScene from "../scenes/GameScene";
import SoundManager from "../managers/SoundManager";

export enum EnergyBallStates {
    hostile = 0,
    friendly = 1
};

export default class EnergyBall extends Phaser.Physics.Arcade.Sprite {
    speed: number;
    endtimeout: Phaser.Time.TimerEvent;

    constructor(scene: Phaser.Scene, x: number,y: number){
        super(scene,x,y,"energyBall");
        scene.add.existing(this);
        scene.physics.add.existing(this);
        this.speed = 200;
        this.body.setMass(0.1);
        this.body.setCircle(3);
        this.body.setOffset(13,13);
        this.setScale(2.5);
        this.name = "energyBall";

        const spritesheet = "energyBallSpriteSheet";

        this.scene.anims.create({
            'key': `${this.name}FlashHostile`,
            'frameRate': 6,
            'frames': this.scene.anims.generateFrameNumbers(spritesheet, { frames: [0,1] }),
            'repeat': -1
        });
        this.scene.anims.create({
            'key': `${this.name}FlashFriendly`,
            'frameRate': 6,
            'frames': this.scene.anims.generateFrameNumbers(spritesheet, { frames: [2,3] }),
            'repeat': -1
        });
        this.scene.anims.create({
            'key': `${this.name}Explode`,
            'frameRate': 6,
            'frames': this.scene.anims.generateFrameNumbers(spritesheet, { frames: [4,5,6] }),
            'repeat': 0
        });

    }

    setState(newState: EnergyBallStates){
        switch(newState){
            case EnergyBallStates.hostile:
                this.play(`${this.name}FlashHostile`);
            break;
            case EnergyBallStates.friendly:
                this.play(`${this.name}FlashFriendly`);
                this.endtimeout.remove();
            break;
        }
        this.state = newState;
        return this;
    }

    getState(){
        return this.state;
    }

    fire(direction: Phaser.Math.Vector2, state: EnergyBallStates = EnergyBallStates.hostile){
        SoundManager.playSfx('energyFiring');
        this.setState(state);
        this.setVisible(true);
        this.setActive(true);
        this.setBounce(this.speed);
        this.setMaxVelocity(this.speed);
        this.setVelocity(direction.x * this.speed, direction.y * this.speed);
        this.endtimeout = this.scene.time.delayedCall(20000,()=> this.end() );
    }

    end(){
        try {
            if(typeof(this) === "undefined") return;
            this.endtimeout.remove();
            const scene = <GameScene>this.scene;
            this.setAcceleration(0);
            this.setVelocity(0);
            this.anims.play(`${this.name}Explode`).once('animationcomplete', ()=>{
                this.setPosition(0,0);
                scene.energyBalls.killAndHide(this);
            })
        }catch(e){
            //do fuck all
        }
    }

}